import propstreamConnectLogo from 'assets/images/propstream-connect.svg';
import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import currencyFormat from 'utils/currency/numberToPrice';
import numberFormat from 'utils/number/format';
import { canceltrialLeadAutomator, selectLeadAutomator, selectUserId, selectPlanDetails, updateSelectedLeadAutomator, selectBillingDashboard } from '../../../data/user';
import css from '../style.scss';
import { connect } from "react-redux";
import LeaveMessagePopup from "../modals/LeaveMessage";
import phoneIcon from "assets/images/phone.svg";
import searchConnectIcon from "assets/images/seatch-connect.svg";
import settingsIcon from "assets/images/settings.svg";
import stampIcon from "assets/images/stamp.svg";
import SimpleModal from '../../../components/base/SimpleModal';
import { useToast } from '../../components/ToastMessage/ToastManager';

const LeadAutomatorScreen = (props) => {
  const leadAutomatorInfo = useSelector(selectLeadAutomator)?.toJS();

  const [plans, setPlans] = useState([]);

  const dispatch = useDispatch();
  const showToast = useToast();
  const planDetails = useSelector(selectPlanDetails)?.toJS();
  const [showCancelTrialModal, setShowCancelTrialModal] = useState(false);
  const [isCancelling, setIsCancelling] = useState(false); // Add loading state 
  const userId = useSelector(selectUserId);
  const billingInfo = useSelector(selectBillingDashboard);

  useEffect(() => {
    if (leadAutomatorInfo?.planMrcs && leadAutomatorInfo?.planMrcs.length > 0 
      && leadAutomatorInfo?.planMrcs.length !== plans.length) {
      setPlans(leadAutomatorInfo?.planMrcs);
    }
  }, [leadAutomatorInfo?.planMrcs]);

  const goToCancelLeadAutomatorTrial = () => {
    setShowCancelTrialModal(true); // Open the modal
  }


  const confirmProceed = async () => {
    setIsCancelling(true); // Disable button and show loading
    
    const canceltrialAutomatorPayload = {
      userId,
    };
    
    try {
      const response = await canceltrialLeadAutomator(canceltrialAutomatorPayload);
      if (response?.success) {
        setShowCancelTrialModal(false);
        showToast("PropStream Connect trial cancelled successfully", "success");
        props.history.push(`/accountnew/landing`);
      } else {
        showToast(response?.data?.message || "Failed to cancel trial", "error");
        setIsCancelling(false); // Re-enable button on error
      }
    } catch (error) {
      showToast("An error occurred while cancelling the trial", "error");
      setIsCancelling(false); // Re-enable button on error
    }
  };

  const cancelRemoveUser = () => {
    setShowCancelTrialModal(false);
    setIsCancelling(false); // Reset loading state if modal is closed
  };

  const goToManageLeadAutomator = (type) => {
    if (type === 'unsubscribe') {
      dispatch(updateSelectedLeadAutomator(null));
    }
    if ((!leadAutomatorInfo?.selectedLead || !leadAutomatorInfo?.selectedLead?.id) && type !== 'unsubscribe') {
      props.leaveMessagePopup({
        title: "Please select a plan",
        message: "Please select a plan to continue",
        cancelLable: '',
        yesLable: 'Close',
      });
      return;
    }
    props.history.push(`/accountnew/manageleadautomator/${type}`);
  };

  const goToAccount = () => {
    props.leaveMessagePopup({
      title: "Are you sure want to leave?",
      message: "Please press yes to leave the page, no to stay on the page",
      cancelLable: 'No',
      yesLable: 'Yes',
      yesRedirect: () => {
        props.history.push(`/accountnew/landing`);
      },
    });
  };

  const isTrialActive = planDetails?.usedLATrial === false;

  useEffect(() => {
  
  if (!planDetails?.usedLATrial && plans.length > 0) {
    // Always select the first plan during trial
    if (!leadAutomatorInfo?.selectedLead || leadAutomatorInfo.selectedLead.id !== plans[0].id) {
      dispatch(updateSelectedLeadAutomator(plans[0]));
    }
  }
}, [planDetails?.usedLATrial, plans, leadAutomatorInfo?.selectedLead, dispatch]);

  
  const getPlanName = () => {
    if (planDetails?.accountEnrolledPlans && planDetails?.accountEnrolledPlans.length > 0) {
      const selectedPlan = planDetails.availableUserPlans.find(plan => plan.id === planDetails?.accountEnrolledPlans[0]?.planId);
      if (selectedPlan && selectedPlan?.name) return selectedPlan.name.split(' ')[0];
      return "";
    }
    return "";
  }
  return (
    <>
      <div className={css.clsInnerMainBody}>
        <div className={classNames("d-flex align-items-center")}>
          <div className="container">
            <div className={classNames(css.clsLeamAutoMainSec, "align-items-center", "d-flex")} style={{"minHeight": "calc(100vh - 100px)"}}>
              <div className="row justify-content-center" style={{"paddingBottom": '13rem'}}>
                <div className="col-lg-7">
                  <div className={css.clsLAMainLeft}>
                    <div>
                      <img className={css.clsLAImgLarge} src={propstreamConnectLogo} alt="propstreamConnectLogo" />
                      <div className={css.clsLAMainHeading}>Everything you need to launch your first outbound marketing campaign—all in one place and at a lower cost.</div>
                    </div>
                    <div className={css.clsLADivider}></div>
                    <div className={css.clsLAMainInfo}>
                      <div className={css.clsLAInfo}>
                        <img className={css.clsLAInfoImg} src={searchConnectIcon} alt="searchConnectIcon" />
                        <div className={css.clsLAInfoDesc}><span className={css.clsLAInfoTitle}>Free Skip Tracing - </span>Get contact details for individual property owners, LLCs, and corporate entities. <span style={{ fontStyle: 'italic' }}>Equal to your current number of account saves.</span></div>
                      </div>
                      <div className={css.clsLAInfo}>
                        <img className={css.clsLAInfoImg} src={settingsIcon} alt="settingsIcon" />
                        <div className={css.clsLAInfoDesc}><span className={css.clsLAInfoTitle}>Lead Automator - </span>Stay updated on your best leads with automated tracking, including new prospect alerts and dead lead removal</div>
                      </div>
                      <div className={css.clsLAInfo}>
                        <img className={css.clsLAInfoImg} src={phoneIcon} alt="phoneIcon" />
                        <div className={css.clsLAInfoDesc}><span className={css.clsLAInfoTitle}>Free Dialer Campaign and Click-to-Dial - </span>Includes AI prompts & up to 150 call attempts per day.</div>
                      </div>
                      <div className={css.clsLAInfo}>
                        <img className={css.clsLAInfoImg} src={stampIcon} alt="stampIcon" />
                        <div className={css.clsLAInfoDesc}><span className={css.clsLAInfoTitle}>Save on Direct Mail - </span>As low as 48¢ per postcard.</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5" style={isTrialActive ? {alignContent:'center' } : null}>
                  <div className={css.clsLAMainRight}>
                    <div className={css.clsLASubscribeHeading}>
                      {!isTrialActive && "Select the number of properties you want to monitor with Lead Automator below."}
                    </div>
                    
                    <ul className={css.clsLASubscribeList}>
                      {isTrialActive ? (
                        // Show only first plan during trial
                        plans.length > 0 && (
                          <li
                            key={plans[0].id}
                            className={`${css.clsLASubscribeItem} ${css.trialPlanItem} ${css.recommendedPlan}`}
                            onClick={() => {
                              if(plans[0].quantity !== leadAutomatorInfo?.monitoredProperties)
                                dispatch(updateSelectedLeadAutomator(plans[0]));
                            }}
                          >
                            <a href="javascript:;"
                              className={`${css.clsLASubscribeLinkTrial} ${leadAutomatorInfo?.selectedLead?.id === plans[0].id ? css.selected : ""}`}>
                              <div className={css.clsLASubscribeLeftTrialTxt}>
                                <h4 className={css.clsLASubscribeTxt1}>{numberFormat(plans[0].quantity)}</h4>
                                <p className={css.clsLASubscribeTxt2}>Monitored Properties</p>
                              </div>
                              
                              <div className={css.clsLASubscribeTrialRightTxt}>
                                <div className={css.clsLASubscribeTrialPrice}>
                                  Free for 14 days,
                                </div>
                                <div className={css.clsLASubscribeTrialPrice}> then {currencyFormat(plans[0].amount)}
                                  <span className={css.trialPricemo}>/mo</span>
                                </div>
                              </div>
                            </a>
                          </li>
                        )
                      ) : (
                        plans.length > 0 && (
                          <>
                            {/* First plan with trial style and RECOMMENDED badge */}
                            <li
                              key={plans[0].id}
                              className={`${css.clsLASubscribeItem} ${css.trialPlanItem} ${css.recommendedPlan}`}
                              onClick={() => {
                                if(plans[0].quantity !== leadAutomatorInfo?.monitoredProperties)
                                  dispatch(updateSelectedLeadAutomator(plans[0]));
                              }}
                            >
                              <a href="javascript:;"
                                className={`${css.clsLASubscribeLinkTrial} ${css.clsLASubscribeLinkRecommended} ${leadAutomatorInfo?.selectedLead?.id === plans[0].id ? css.selected : ""}`}>
                                <div className={css.recommendedBadge}>RECOMMENDED</div>
                                <div className={css.clsLASubscribeLeftTrialTxt}>
                                  <h4 className={css.clsLASubscribeTxt1}>{numberFormat(plans[0].quantity)}</h4>
                                  <p className={css.clsLASubscribeTxt2}>Monitored Properties</p>
                                </div>
                                
                                {(plans[0]?.id === leadAutomatorInfo?.accountPlanMrcs?.[0]?.id ||
                                    plans[0]?.quantity === leadAutomatorInfo?.accountPlanMrcs?.[0]?.quantity
                                  ) && (
                                  <div style={{marginBottom:'6px'}} className={css.clsLASubscribeBtn}>
                                    <button className={classNames(css.btn_primary, css.clsBtnPrimaryGreen)}>Current Plan</button>
                                  </div>
                                )}

                                <div className={css.clsLASubscribeTrialRightTxt}>
                                  <div className={css.clsLASubscribeTrialPrice}>
                                    {currencyFormat(plans[0].amount)}
                                    <span className={css.trialPricemo}>/mo</span>
                                  </div>
                                </div>
                              </a>
                            </li>

                            {/* Remaining plans with regular style */}
                            {plans.slice(1).map((plan) => (
                              <li
                                key={plan.id}
                                className={`${css.clsLASubscribeItem} `}
                                onClick={() => {
                                  if(plan.quantity !== leadAutomatorInfo?.monitoredProperties)
                                    dispatch(updateSelectedLeadAutomator(plan));
                                }}
                              >
                                <a href="javascript:;"
                                  className={`${css.clsLASubscribeLink} ${leadAutomatorInfo?.selectedLead?.id === plan.id ? css.selected : ""}`}>
                                  <div className={css.clsLASubscribeLeftTxt}>
                                    <h4 className={css.clsLASubscribeTxt1}>{numberFormat(plan.quantity)}</h4>
                                    <p className={css.clsLASubscribeTxt2}>Monitored Properties</p>
                                  </div>
                                  {(plan?.id === leadAutomatorInfo?.accountPlanMrcs?.[0]?.id ||
                                    plan?.quantity === leadAutomatorInfo?.accountPlanMrcs?.[0]?.quantity
                                  ) && (
                                    <div className={css.clsLASubscribeBtn}>
                                      <button className={classNames(css.btn_primary, css.clsBtnPrimaryGreen)}>Current Plan</button>
                                    </div>)}

                                  <div className={css.clsLASubscribeRightTxt}>
                                    <h4 className={css.clsLASubscribeTxt1}>{currencyFormat(plan.amount)}<sub>/mo</sub></h4>
                                  </div>
                                </a>
                              </li>
                            ))}
                          </>
                        )
                      )}
                    </ul>

                    <div className="d-flex justify-content-center">
                      {leadAutomatorInfo?.monitoredProperties > 0 && (
                       planDetails?.usedLATrial && leadAutomatorInfo?.accountPlanMrcs?.length > 0 && (leadAutomatorInfo?.accountPlanMrcs[0]?.planType === "Trial Plan Promo" ||  leadAutomatorInfo?.accountPlanMrcs[0]?.planType === "Annual Plan Promo") ? 
                      <p className={css.clsLAUnSubscribeTxt}  onClick={() => goToCancelLeadAutomatorTrial()}>Cancel PropStream Connect Trial</p>:
                      <p  className={`${css.clsLAUnSubscribeTxt} ${billingInfo?.psConnectStatus == "UNSUBSCRIBED" ? css.disabled : ''}`}  onClick={() => {if (billingInfo?.psConnectStatus !== 'UNSUBSCRIBED') { goToManageLeadAutomator('unsubscribe');}}}>Unsubscribe from PropStream Connect</p>)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={css.clsInnerFooter}>
          <button className={classNames(css.clsBackBtn)} onClick={() => goToAccount()}> Cancel</button>
          <button className={classNames(css.btn_xl, css.btn_primary, css.clsBtnPrimaryGreen)} 
            disabled={!leadAutomatorInfo?.selectedLead || (planDetails?.usedLATrial && planDetails?.trialAvailable)}
            onClick={() => goToManageLeadAutomator('review')}> Continue</button>
        </div>
      </div>

      {showCancelTrialModal && (
        <SimpleModal
          title="Confirm Trial Cancellation"
          description="If you cancel now, you will lose access to all PropStream Connect features."
          onCancel={cancelRemoveUser}
          modalClassName={css.cancleModal}
          customFooter={
            <div className={css.customFooter}
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}>
              <button
                className={css.cancelSBtn}
                onClick={cancelRemoveUser}
                disabled={isCancelling} // Disable while loading
              >
                Cancel
              </button>

              <button
                className={`${css.clsTextPrimaryGreen} ${css.btn_lg}`}
                onClick={confirmProceed}
                disabled={isCancelling} // Disable while loading
              >
                Proceed
              </button>
            </div>
          }
        />
      )}
    </>
  );
};


export default withRouter(connect(null, {
  leaveMessagePopup: LeaveMessagePopup.open,
  leaveMessagePopupClose: LeaveMessagePopup.close
})(LeadAutomatorScreen));
